import React from 'react';
import { HistoryPoint } from './types';
import { StandardId } from '../compliance/types';
import * as fmt from '../../lib/format';

// Your last six months for one standard. The month on screen is the dark bar; the percentage is also
// written above each bar and in the summary read out by screen readers.
export default function HistoryStrip({ points, standard, label, current }: { points: HistoryPoint[]; standard: StandardId; label: string; current: string }) {
  if (points.length < 2) return null;
  const summary = points.map((p) => `${fmt.month(p.period)} ${fmt.percent(p[standard])}`).join(', ');
  return (
    <div role="img" aria-label={`${label} by month: ${summary}`}>
      <div className="text-[0.6875rem] font-semibold uppercase tracking-wider text-gray-500">Your last six months</div>
      <ol className="mt-2 flex items-end gap-2 sm:gap-3" aria-hidden>
        {points.map((p) => {
          const on = p.period === current;
          const value = p[standard];
          return (
            <li key={p.period} className="flex min-w-0 flex-1 flex-col items-center gap-1 sm:w-12 sm:flex-none">
              <span className={`text-xs tabular-nums ${on ? 'font-semibold text-gray-900' : 'text-gray-600'}`}>{fmt.percent(value)}</span>
              <div className="flex h-14 w-full items-end overflow-hidden rounded-md bg-gray-100">
                <div
                  className={`w-full rounded-md transition-[height] duration-300 ease-out motion-reduce:transition-none ${on ? 'bg-gray-800' : 'bg-gray-500'}`}
                  style={{ height: `${Math.max(value === null ? 0 : 4, value ?? 0)}%` }}
                />
              </div>
              <span className={`text-xs ${on ? 'font-semibold text-gray-900' : 'text-gray-600'}`}>{fmt.monthAbbr(p.period)}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
